import { SITE_CONFIG_KEY } from '../constants/types/site-config-type';
import { useSiteConfig } from './useSiteConfig';

const FREE_TRIAL_SITE_CONFIG_FALLBACK = {
  BLOG_REVIEW: 'https://blog.naver.com/jebs_jemm',
  PRIMARY_BLOG_REVIEW: 'https://blog.naver.com/jebs_jemm/224439189744',
  PRIMARY_BLOG_TITLE: '젭스로 자란 아이가 중학생이 되면 어떨까요?',
  YOUTUBE_REVIEW: 'https://www.youtube.com/@JEBS.official',
  PRIMARY_YOUTUBE_REVIEW: 'https://youtu.be/kx4b8GMXVf8?si=MbGV1ro3t05PpCRa',
  PRIMARY_YOUTUBE_TITLE: '남달랐던 영어 자신감, 말씀으로 배운 영어에 있었어요!',
  SEMINAR_APPLY: 'https://forms.gle/hYg6Q4YQ4tMcBFb58',
  SEMINAR_VIDEO: 'https://www.youtube.com/watch?v=m4ShOqs_7To',
  KAKAO: 'https://pf.kakao.com/_LZRdE',
};

const SITE_CONFIG_KEYS = [
  SITE_CONFIG_KEY.FREE_TRIAL_BLOG_REVIEW,
  SITE_CONFIG_KEY.FREE_TRIAL_PRIMARY_BLOG_REVIEW,
  SITE_CONFIG_KEY.FREE_TRIAL_PRIMARY_BLOG_TITLE,
  SITE_CONFIG_KEY.FREE_TRIAL_YOUTUBE_REVIEW,
  SITE_CONFIG_KEY.FREE_TRIAL_PRIMARY_YOUTUBE_REVIEW,
  SITE_CONFIG_KEY.FREE_TRIAL_PRIMARY_YOUTUBE_TITLE,
  SITE_CONFIG_KEY.FREE_TRIAL_SEMINAR_APPLY,
  SITE_CONFIG_KEY.FREE_TRIAL_SEMINAR_VIDEO,
  SITE_CONFIG_KEY.FREE_TRIAL_KAKAO,
];

/**
 * 무료체험 신청의 외부 링크 조회
 * 조회 실패 또는 빈 값이면 폴백 문구를 반환한다.
 */
export const useFreeTrialConfig = () => {
  const { configs } = useSiteConfig(SITE_CONFIG_KEYS);
  return {
    FREE_TRIAL_BLOG_REVIEW:
      configs[SITE_CONFIG_KEY.FREE_TRIAL_BLOG_REVIEW] ||
      FREE_TRIAL_SITE_CONFIG_FALLBACK.BLOG_REVIEW,
    FREE_TRIAL_PRIMARY_BLOG_REVIEW:
      configs[SITE_CONFIG_KEY.FREE_TRIAL_PRIMARY_BLOG_REVIEW] ||
      FREE_TRIAL_SITE_CONFIG_FALLBACK.PRIMARY_BLOG_REVIEW,
    FREE_TRIAL_PRIMARY_BLOG_TITLE:
      configs[SITE_CONFIG_KEY.FREE_TRIAL_PRIMARY_BLOG_TITLE] ||
      FREE_TRIAL_SITE_CONFIG_FALLBACK.PRIMARY_BLOG_TITLE,
    FREE_TRIAL_YOUTUBE_REVIEW:
      configs[SITE_CONFIG_KEY.FREE_TRIAL_YOUTUBE_REVIEW] ||
      FREE_TRIAL_SITE_CONFIG_FALLBACK.YOUTUBE_REVIEW,
    FREE_TRIAL_PRIMARY_YOUTUBE_REVIEW:
      configs[SITE_CONFIG_KEY.FREE_TRIAL_PRIMARY_YOUTUBE_REVIEW] ||
      FREE_TRIAL_SITE_CONFIG_FALLBACK.PRIMARY_YOUTUBE_REVIEW,
    FREE_TRIAL_PRIMARY_YOUTUBE_TITLE:
      configs[SITE_CONFIG_KEY.FREE_TRIAL_PRIMARY_YOUTUBE_TITLE] ||
      FREE_TRIAL_SITE_CONFIG_FALLBACK.PRIMARY_YOUTUBE_TITLE,
    FREE_TRIAL_SEMINAR_APPLY:
      configs[SITE_CONFIG_KEY.FREE_TRIAL_SEMINAR_APPLY] ||
      FREE_TRIAL_SITE_CONFIG_FALLBACK.SEMINAR_APPLY,
    FREE_TRIAL_SEMINAR_VIDEO:
      configs[SITE_CONFIG_KEY.FREE_TRIAL_SEMINAR_VIDEO] ||
      FREE_TRIAL_SITE_CONFIG_FALLBACK.SEMINAR_VIDEO,
    FREE_TRIAL_KAKAO:
      configs[SITE_CONFIG_KEY.FREE_TRIAL_KAKAO] ||
      FREE_TRIAL_SITE_CONFIG_FALLBACK.KAKAO,
  };
};
